import { TableHead } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { blueGrey, grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import {
  DEFAULT_CHAIN_STORE_MODAL_STATE,
  MODAL_STATE,
} from "../../chain_store/ChainStoreUtils";
import ChainStoreInfoModal from "./ChainStore/ChainStoreInfoModal";

const infoTableCellSx = {
  fontSize: 18,
};
const columns = ["取引先", "商品種別コード", "商品コード", "商品名", ""];

export const ChainStoreProductList = (props) => {
  const {
    productId,
    listChainStoreProduct,
    onClickDeleteChainStoreProduct,
    FetchChainStoreProduct,
  } = props;
  const modalState = useInputObject(DEFAULT_CHAIN_STORE_MODAL_STATE);
  const navigate = useNavigate();

  return (
    <>
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              チェーンストア商品一覧
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              onClick={() => {
                // modalState.setValue(DEFAULT_CHAIN_STORE_MODAL_STATE);
                modalState.update("open", true);
                // modalState.update("mode", MODAL_STATE.INSERT);
                modalState.update("productId", productId);
                // modalState.update("customerId", null);
              }}
            >
              チェーンストア商品登録
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {columns.map((columnName, i) => {
                return (
                  <TableCell
                    key={`${columnName}_${i}`}
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {columnName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {listChainStoreProduct.map((data, i) => (
              <TableRow
                key={i}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                  visibility: data.customerName ? "inherit" : "hidden",
                }}
              >
                {/* 産地 */}
                <TableCell sx={{ ...infoTableCellSx, width: 400 }}>
                  {data.customerName || ""}
                </TableCell>
                {/* 等級 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.chainStoreProductTypeCd || ""}
                </TableCell>
                {/* 階級 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.chainStoreProductCd || ""}
                </TableCell>
                {/* 重量 */}
                <TableCell sx={{ ...infoTableCellSx, width: 400 }}>
                  {data.chainStoreProductName || ""}
                </TableCell>
                {/* 編集・削除 */}
                <TableCell
                  sx={{
                    width: "95%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{ marginRight: 3 }}
                    onClick={() => {
                      modalState.updates({
                        open: true,
                        mode: MODAL_STATE.UPDATE,
                        productId,
                        updateElement: data,
                      });
                    }}
                  >
                    編集
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      onClickDeleteChainStoreProduct(data);
                    }}
                  >
                    削除
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ChainStoreInfoModal
        modalState={modalState}
        onClose={FetchChainStoreProduct}
      />
    </>
  );
};
